import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Breadcrumbs,
  Link,
  Typography,
  Box
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  Build as BuildIcon,
  Map as MapIcon
} from '@mui/icons-material';

const InstallBaseBreadcrumbs = ({ 
  customerName, 
  customerId, 
  locationName, 
  locationId, 
  installationName, 
  installationId 
}) => {
  // Build breadcrumbs in reverse order (current page to root)
  const breadcrumbs = [];

  // Add current page (non-clickable)
  if (installationName && installationId) {
    breadcrumbs.unshift({
      label: installationName,
      icon: <BuildIcon sx={{ mr: 0.5 }} fontSize="small" />,
      isCurrent: true
    });
  } else if (locationId) {
    // Always show location name on location page, with fallback
    breadcrumbs.unshift({
      label: locationName || `Location ${locationId}`,
      icon: <LocationIcon sx={{ mr: 0.5 }} fontSize="small" />,
      isCurrent: true
    });
  }

  // Add parent nodes (clickable)
  if (locationName && locationId && installationName) {
    // Only add location as clickable if we're on the installation page
    breadcrumbs.unshift({
      label: locationName,
      href: `/locations/${locationId}`,
      icon: <LocationIcon sx={{ mr: 0.5 }} fontSize="small" />
    });
  }

  if (customerName && customerId) {
    breadcrumbs.unshift({
      label: customerName,
      href: `/install-base/customer/${customerId}`,
      icon: <BusinessIcon sx={{ mr: 0.5 }} fontSize="small" />
    });
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Breadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="install base navigation"
      >
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          
          return crumb.isCurrent ? (
            <Typography
              key={crumb.label}
              color="text.primary"
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              {crumb.icon}
              {crumb.label}
            </Typography>
          ) : (
            <Link
              key={crumb.href}
              component={RouterLink}
              to={crumb.href}
              color="inherit"
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                },
                fontSize: '0.875rem'
              }}
            >
              {crumb.icon}
              {crumb.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default InstallBaseBreadcrumbs; 